/**
 * Copyright © 2016 Magento. All rights reserved.
 * See COPYING.txt for license details.
 */
define([
    'jquery',
    'uiComponent',
    'Magento_Customer/js/customer-data',
    'notifications',
    'jquery/jquery-storageapi',
], function ($, Component, customerData, Notifications) {
    'use strict';

    return Component.extend({
        defaults: {
            cookieMessages: [],
            messages: []
        },
        initialize: function () {
            this._super();

            var cookieMessages = $.cookieStorage.get('mage-messages');
            
            this.messages = customerData.get('messages').extend({disposableCustomerData: 'messages'});
            $.cookieStorage.setConf({path: '/', expires: 1}).set('mage-messages', null);

            if (cookieMessages != null && cookieMessages.length > 0) {
                $.each(cookieMessages, function(index, message) {
                    if (message.type === 'success') {
                        Notifications.createSuccessNotification(message.text);
                    } else if (message.type === 'error') {
                        Notifications.createErrorNotification(message.text);
                    } else {
                        Notifications.createNotification({text: message.text});
                    }
                });

                // Any messages that were saved in cookieStorage will now have been displayed, so they can be removed
                $.cookieStorage.set('mage-messages', [])
            }
        }
    });
});
